import styled from '@emotion/styled'
import * as v from 'variables/styled'

export const LayoutContainer = styled.div(props => ({
  display: 'flex',
  flex: 1,
  flexDirection: 'column',
  height: 'fit-content',
  width: '100vw',

  '.MuiAppBar-colorPrimary':{
    backgroundColor: 'rgb(251, 191, 102)'
  },

  '.MuiPaper-elevation4':{
    boxShadow:'none'
  },
  
  '.MuiAppBar-root':{
    zIndex:'auto'
  }
  
}))

export const MainContainer = styled.div(props => ({
  display: 'flex',
  flex: 1,
  width: '100%',
  height: '100%',
}))

export const BodyContainer = styled.div(props => ({
  display: 'flex',
  flex: 1,
  minHeight: 'calc(100vh - 64px)',
  width: `calc(100vw - ${v.menuWidth(props.showMenu, props.collapseMenu)})`,
  backgroundColor:'rgb(245, 246, 250)',
  maxWidth: '100%',
}))